import { useMutation } from "@apollo/client";
import { GetAccountQuery } from "types/graphql-schema";

import AiKnowledgeEditor from "@components/ai-knowledge-editor/ai-knowledge-editor";
import SettingsLayout from "@components/settings-layout/settings-layout";
import { assertNonNull } from "@helpers/helpers";

import updateUserMutation from "../../graphql/update-user-mutation";

const AiPreferencesSection = ({ me }: { me: GetAccountQuery["me"] }) => {
  const [updateUser] = useMutation(updateUserMutation);

  const handleSaveAiKnowledge = async (jsonValue: string) => {
    if (assertNonNull(me).aiGuidelines === jsonValue) return;

    await updateUser({
      variables: {
        userId: assertNonNull(me).id,
        aiGuidelines: jsonValue,
      },
    });
  };

  return (
    <div aria-label="AI preferences section" className="pb-12">
      <SettingsLayout.Container>
        <SettingsLayout.Row>
          <SettingsLayout.Left label="Add knowledge specific to your account to personalize Topicflow AI.">
            About you
          </SettingsLayout.Left>
          <SettingsLayout.Right>
            <div className="w-full">
              <AiKnowledgeEditor
                value={assertNonNull(me).aiGuidelines || null}
                onSave={handleSaveAiKnowledge}
                label="AI Preferences"
                description="Add details about your role, preferences, and working context so Topicflow AI can personalize responses for you."
                placeholder="Add context Topicflow AI should know about you, your role, and your preferences."
              />
            </div>
          </SettingsLayout.Right>
        </SettingsLayout.Row>
      </SettingsLayout.Container>
    </div>
  );
};

export default AiPreferencesSection;
